/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/style-prop-object */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes, { any } from 'prop-types';

import AvatarV3 from './AvatarV3';
import RatingDisplayV3 from '../RatingDisplayV3';
import RatingDisplayV5 from '../RatingDisplayV5';
import ShareUrlPopUp from '../../InfoPopUps/ShareUrlPopUp';
import JoinMeOnTourPopUp from '../../PopUps/JoinMeOnTourPopup';
import UnClaimedProfileMessagePopup from '../../PopUps/UnClaimedProfileMessagePopup';
import Img from '../../Img';
import TrackedClick from '../../Analytics/TrackedClick';
import withAuth from '../../hocs/withAuth';
import { getClickAttrs } from '../../Analytics/gtag';
import { useStatsig } from '../../hooks/useStatsig';

import config from '../../../../config';

import styles from './headerV3.scss';

const ProfileHeader = (props) => {
    const { playerId, isEligibleForPaidHit, isSendingPaidHitRequest, onRequestPaidHitClicked, onViewPaidHitsClicked, isPlayerSavedToList, 'data-testid': dataTestId } = props;
    const {
        profileImage,
        playerProfileImages,
        firstName,
        lastName,
        displayName,
        homeClub,
        location,
        descriptionId,
        playerCollegeDetails,
        descriptionLong,
        gender,
        residence,
    } = props.profileData;

    const { claimedPlayer, isPowered } = props?.auth?.user || {};

    const userLoggedIn = props?.auth?.user;
    const isOwnProfile = userLoggedIn && ((props.profileData && claimedPlayer) ? (props.profileData.id === claimedPlayer.playerId) : false);
    const isProProfile = props?.profileData?.isPro;
    const isProfileClaimed = props?.profileData?.claimed;
    const isPaidHitter = props?.profileData?.isPaidHitter;

    const {
        handleUploadPhoto,
        handleUploadPhotoPhotoStart,
        handleRemoveProfilePhoto,
        menuSelected,
    } = props;

    const { checkGate, featureGates } = useStatsig();
    const isRatingsV4Enabled = checkGate(featureGates.RATING_V4);

    const handleOnLinkCopied = () => {
        if (window && window.analytics) {
            const path = '/share/player';
            const properties = {
                path,
                url: path,
                title: props.profileData.displayName,
            };

            window.analytics.page('share player profile', 'share link', properties);
        }
    };

    const handleOnRequestPaidHitClicked = () => {
        onRequestPaidHitClicked();
    };

    const handleOnViewPaidHitsClicked = () => {
        onViewPaidHitsClicked();
    };

    const onTennisGetRatedClick = () => {
        props.history.push(`/onboarding-survey?return=/profiles/${props.profileData.id}`);
    };

    const onPickleballGetRatedClick = () => {
        props.history.push(`/pickleball-survey?return=/profiles/${props.profileData.id}`);
    };

    const handleProfileMerge = () => {
        menuSelected({
            label: 'Request Profile Merge',
            value: 'RPM',
            redirectPath: `https://support.${config.siteBaseUrl}/support/tickets/new`,
            redirectSearch: ``,
        });
    };

    const handleSaveToList = () => {
        menuSelected({
            label: 'Save to List',
            value: 'STL',
            redirectPath: `/save-to-list/players/${playerId}`,
            redirectSearch: `?next=/profiles/${playerId}`,
        });
    };

    const renderIcons = () => (
        <>
            {!isOwnProfile && (
                <div
                    className={`${styles.icon}`}
                    onClick={() => {
                                isProProfile && !isPaidHitter ? props.setIsProMessagePopupFlg(true)
                                    : (!isProfileClaimed ? props.setUnclaimedProfileMessagePopup(true) : props.handleShowLoginPopUp('message', true));
                            }}
                    data-testid={dataTestId ? `${dataTestId}.message-btn` : undefined}
                >
                    <Img src={'/img/v3/icons/icon-24px-message-white.svg'} />
                </div>
            )}
            <ShareUrlPopUp
                title="Share Profile"
                className={`text-uppercase`}
                linkCopied={handleOnLinkCopied}
                data-testid={dataTestId ? `${dataTestId}.share-popup` : undefined}
            >
                <div className={`${styles.icon}`} data-testid={dataTestId ? `${dataTestId}.share-btn` : undefined}>
                    <Img src={'/img/v3/icons/icon-24px-share-white.svg'} />
                </div>
            </ShareUrlPopUp>
            {isPowered && (
                <div className={`${styles.icon}`} onClick={handleSaveToList} data-testid={dataTestId ? `${dataTestId}.save-to-list-btn` : undefined}>
                    <Img src={`${'/img/v3/icons/icon-24px-'}${isPlayerSavedToList ? 'following.svg' : 'follow.svg'}`} />
                </div>
            )}
        </>
    );

    const renderButtons = () => (
        <div className={styles.btnWrapper}>
            {isOwnProfile && (
                <TrackedClick
                    eventName="Profile Edit Info Clicked"
                    label="Edit profile"
                    traits={{}}
                >
                    <button
                        type="button"
                        onClick={() => {
                            props.history.push(`/profiles/${playerId}/edit`);
                        }}
                        className={`btn btn-white btn-inv btn-sm text-uppercase`}
                        data-testid={dataTestId ? `${dataTestId}.edit-profile-btn` : undefined}
                        {...getClickAttrs({
                            category: `Player Profile`,
                            context: `Edit profile`,
                            location: 'Player Profile CTA',
                        })}
                    >
                        Edit profile
                    </button>
                </TrackedClick>
            )}
            {isEligibleForPaidHit && (
                <>
                    {!isOwnProfile && (
                        <button
                            type="button"
                            className={`${styles.paidHitButton} btn btn-white btn-inv btn-sm text-uppercase`}
                            onClick={handleOnRequestPaidHitClicked}
                            disabled={isSendingPaidHitRequest}
                            data-testid={dataTestId ? `${dataTestId}.request-paid-hit-btn` : undefined}
                        >
                            {isSendingPaidHitRequest ? 'Sending...' : 'Request Paid Hit'}
                        </button>
                    )}
                    <button
                        type="button"
                        className={`${styles.paidHitButton} btn btn-white btn-inv btn-sm text-uppercase`}
                        onClick={handleOnViewPaidHitsClicked}
                        data-testid={dataTestId ? `${dataTestId}.view-paid-hits-btn` : undefined}
                    >
                        View Paid Hits
                    </button>
                </>
            )}
        </div>
    );

    return (
        <div className={`${styles.profileHeader}`} data-testid={dataTestId}>
            <div className={`${styles.header}`}>
                <div className={`container`}>
                    <div className={`${styles.playerDetails}`}>
                        <div className={`${styles.detailsWrapper}`}>
                            <div className={`${styles.flexColumn} ${styles.avatarAndDetails}`}>
                                <AvatarV3
                                    firstName={firstName}
                                    lastName={lastName}
                                    playerProfileImages={playerProfileImages}
                                    isOwnProfile={isOwnProfile}
                                    profileImage={profileImage}
                                    handleUploadPhoto={handleUploadPhoto}
                                    handleUploadPhotoPhotoStart={handleUploadPhotoPhotoStart}
                                    handleRemoveProfilePhoto={handleRemoveProfilePhoto}
                                    data-testid={dataTestId ? `${dataTestId}.avatar` : undefined}
                                />
                                <div className={`${styles.detailsContainer}`}>
                                    <h1 className={`${styles.playerName}`} data-testid={dataTestId ? `${dataTestId}.player-name` : undefined}>
                                        <span>{displayName}</span>
                                    </h1>
                                    <div className={`${styles.playerLocation}`} data-testid={dataTestId ? `${dataTestId}.player-location` : undefined}>
                                        {(descriptionId !== 0 && playerCollegeDetails) ? (
                                            <Link className={styles.playerLocationLink} to={`/colleges/${descriptionId}?t=1`} data-testid={dataTestId ? `${dataTestId}.college-link` : undefined}>
                                                {descriptionLong}
                                            </Link>
                                        ) : (
                                            <>
                                                {descriptionLong || residence}
                                                {homeClub && ((location?.display) || descriptionLong) && (
                                                    <span>&nbsp;<span className={`${styles.middleDot}`}>&nbsp;</span>&nbsp;</span>
                                                )}
                                                {homeClub || ''}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.flexColumn} ${styles.ratingsContainer}`}>
                                {isRatingsV4Enabled ? (
                                    <RatingDisplayV5
                                        profileData={props.profileData}
                                        handleSignInClick={() => {
                                            props.handleShowLoginPopUp('ratingDisplay');
                                        }}
                                        isProProfile={isProProfile}
                                        auth={props.auth}
                                        isOwnProfile={isOwnProfile}
                                        onTennisGetRatedClick={onTennisGetRatedClick}
                                        onPickleballGetRatedClick={onPickleballGetRatedClick}
                                        data-testid={dataTestId ? `${dataTestId}.rating` : undefined}
                                    />
                                ) : (
                                    <RatingDisplayV3
                                        profileData={props.profileData}
                                        handleSignInClick={() => {
                                            props.handleShowLoginPopUp('ratingDisplay');
                                        }}
                                        isProProfile={isProProfile}
                                        auth={props.auth}
                                        isOwnProfile={isOwnProfile}
                                        onTennisGetRatedClick={onTennisGetRatedClick}
                                        onPickleballGetRatedClick={onPickleballGetRatedClick}
                                        data-testid={dataTestId ? `${dataTestId}.rating` : undefined}
                                    />
                                )}
                            </div>
                            <div className="d-block d-md-none mt20">
                                {renderButtons()}
                            </div>
                            <div className={`${styles.flexColumn} ${styles.iconsContainer} d-none d-md-flex`}>
                                {renderIcons()}
                            </div>
                        </div>
                        <div className={`${styles.hr}`} />
                        <div className={`${styles.actionsContainer}`}>
                            <div className={`${styles.buttons}`}>
                                <div className={`${styles.icons} d-flex d-md-none`}>
                                    {renderIcons()}
                                </div>
                                <div className="d-none d-md-block">
                                    {renderButtons()}
                                </div>
                            </div>
                            {userLoggedIn && !isProProfile && (
                                <div className={`${styles.links}`}>
                                    <div onClick={handleProfileMerge} data-testid={dataTestId ? `${dataTestId}.profile-merge-link` : undefined}>Request profile merge</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {props.showIsProMessagePopup && (
                    <JoinMeOnTourPopUp
                        message="If you want to play, come join me on the tour!"
                        closePopup={() => props.setIsProMessagePopupFlg(false)}
                    />
                )}
                {props.showUnclaimedProfileMessagePopup && (
                    <UnClaimedProfileMessagePopup
                        firstname={firstName}
                        gender={gender}
                        onCloseClick={() => props.setUnclaimedProfileMessagePopup(false)}
                    />
                )}
            </div>
        </div>
    );
};

ProfileHeader.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({
            isPowered: PropTypes.bool,
            claimedPlayer: PropTypes.shape({
                id: PropTypes.number,
            }),
        }),
    }).isRequired,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isEligibleForPaidHit: PropTypes.bool.isRequired,
    isSendingPaidHitRequest: PropTypes.bool.isRequired,
    onRequestPaidHitClicked: PropTypes.func.isRequired,
    onViewPaidHitsClicked: PropTypes.func.isRequired,
    isPlayerSavedToList: PropTypes.bool,
    profileData: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isPro: PropTypes.bool.isRequired,
        isPaidHitter: PropTypes.bool.isRequired,
        claimed: PropTypes.bool.isRequired,
        displayName: PropTypes.string.isRequired,
        profileImage: PropTypes.string,
        playerProfileImages: PropTypes.objectOf(any).isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        homeClub: PropTypes.string,
        location: PropTypes.shape({
            display: PropTypes.string,
        }).isRequired,
        descriptionId: PropTypes.number.isRequired,
        playerCollegeDetails: PropTypes.shape({
            gradYear: PropTypes.string,
            gradClassName: PropTypes.string,
        }),
        descriptionLong: PropTypes.string,
        gender: PropTypes.string.isRequired,
    }).isRequired,
    handleUploadPhoto: PropTypes.func.isRequired,
    handleUploadPhotoPhotoStart: PropTypes.func.isRequired,
    handleRemoveProfilePhoto: PropTypes.func.isRequired,
    menuSelected: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    setIsProMessagePopupFlg: PropTypes.func.isRequired,
    setUnclaimedProfileMessagePopup: PropTypes.func.isRequired,
    handleShowLoginPopUp: PropTypes.func.isRequired,
    showIsProMessagePopup: PropTypes.bool.isRequired,
    showUnclaimedProfileMessagePopup: PropTypes.bool.isRequired,
};

ProfileHeader.defaultProps = {
    isPlayerSavedToList: false,
};

export default withRouter(withAuth(ProfileHeader));
